var map = {
	"./de.json": "B4A8",
	"./en.json": "UpdR",
	"./es.json": "WlTu",
	"./fr.json": "FiWC",
	"./it.json": "tr1a",
	"./ja.json": "1ccB",
	"./nl.json": "6FX3",
	"./pl.json": "M6kd",
	"./pt-BR.json": "tsLY",
	"./pt.json": "Z6Dw",
	"./th.json": "zjzZ",
	"./tr.json": "8EGb",
	"./zh.json": "MvI0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Qcmm";


//////////////////
// WEBPACK FOOTER
// ./src/i18n \.json$
// module id = Qcmm
// module chunks = 105